<template>
    <b-card>
        <div v-if="$store.state.isTablet" >
            <b-row style="font-weight: bold; text-align: start; margin-bottom:10px">
                <span style="text-align: center;">
                      {{getSiteName(this.selectedSite.id)}}
                </span>
            </b-row>
            <b-row align-v="end">
                    <year-select @onchange="onYearChange"/>
                <b-col>
                    <div style="width: 300px" class="placeholder-color-white">
                        <b-form-input v-model="searchInput" @input="filterAudits" :placeholder="$t('searchRecord')" type="text" class="gray-input" style="margin-left: 10px"/>
                    </div>
                </b-col>
            </b-row>
        </div>   
            <div v-else >
                <b-row align-h="between" class="mt-2 mb-4">
                    <b-col style="font-weight: bold; text-align: start;">
                        <span style="text-align: center;">
                            {{getSiteName(this.selectedSite.id)}}
                        </span>
                    </b-col>
                    <b-col cols="9" sm="9" md="7" lg="5" xl="6">
                        <b-row align-h="end" no-gutters>
                            <year-select @onchange="onYearChange" style="margin-right: 15px"/>
                            <site-multi-select
                                :selectedSiteId="selectedSite.id"
                                :givenSites="this.$store.state.sites"
                                @oninput="selectSiteId"/>
                            <b-col style="margin-left:-5px">
                                <b-form-select v-model="selectedAuditType" @change="selectAuditType($event)" class="gray-select" style="height:41px !important">
                                    <option v-for="auditType in auditTypes" :key="auditType.type" :value="auditType.type">{{auditType.name}}</option>
                                </b-form-select>
                            </b-col>
                            <div style="width: 130px; margin-left:5px" class="placeholder-color-white">
                                <b-form-input v-model="searchInput" @input="filterAudits" :placeholder="$t('searchRecord')" type="text" class="gray-input" style="margin-left: 10px"/>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        <div class="table-responsive scroll-content mt-3" style="margin-top: 15px;">
            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                <thead style="position: sticky;background-color: white;top: 0px;z-index:2">
                    <tr v-show="this.$store.state.user.permissions.canCreateAudit" @click="insertRow($event.target,'createDetail')" class="insert-row">
                        <td :colspan="6">
                            <div class="tableBodyCell">
                                <div style="position: absolute; left: 0; top:auto; right: 0; margin:auto; z-index:100px;">
                                    <i class="fas fa-plus-circle fa-2x"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th style="width: 20em;">{{ $t(this.gbId(this.$store.state.user.customerId) ? 'otherEvaluations': 'title')  }}</th>
                        <th style="width: 20em;">{{ $t('auditType')  }}</th>
                        <th style="width: 20em;">{{ $t(this.getGroupName('agent')) }}</th>
                        <th style="width: 20em;">{{ $t('auditDate')  }}</th>
                        <th style="width: 20em;">{{ $t('document')  }}</th>
                        <th/>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(audit,index) in filteredAudits" :key="index">
                        <td style="color: #007bff;">{{audit.title}}</td>
                        <td>{{getAuditType(audit.type)}}</td>
                        <td v-if="selectedSite.agents">
                            <span v-for="(agent,index) in selectedSite.agents" :key="index">
                                <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.agentIds[index]}}">{{ agent ? agent : '-' }} </router-link>
                            </span>
                        </td>
                        <td v-else>
                            -
                        </td>
                        <td v-if="audit.audit_date">{{audit.audit_date | formatDate('YYYY-MM-DD') }}</td>
                        <td v-else>-</td>
                        <td v-if="audit.files.length">
                            <b-button v-b-modal.auditFiles v-b-tooltip.hover :title="$t('Documents')" @click="showAuditFiles(audit.files, $event.target)">
                                <i class="fas fa-file-alt"/>
                            </b-button>
                        </td>
                        <td v-else>-</td>
                        <!-- Edit Section -->
                        <td class="audit-record-edit-buttons">
                            <div class="tableBodyCell">
                                <div :key="'btngroup'" class="table-button-group table-cell">
                                    <b-button style="box-shadow: none;" v-b-tooltip.hover :title="$t('edit')" @click="updateRow($event.target, audit, 'update')">
                                    <i class="fas fa-edit"></i>
                                    </b-button>
                                    <b-button
                                    v-b-modal.warn
                                    v-b-tooltip.hover
                                    :title="$t('delete')"
                                    @click="deleteAudit(audit, $event)"
                                    variant="danger"
                                    style="box-shadow: none;"
                                    >
                                    <i class="fas fa-trash-alt"></i>
                                    </b-button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-card>
</template>

<script>
import _ from 'lodash';
import YearSelect from '../../../components/YearSelect';
import SiteTypeSelect from '../../../components/SiteTypeSelect';
import SiteMultiSelect from '../../../components/SiteMultiSelect';
import RegionMultiSelect from '../../../components/RegionMultiSelect';
import uuid from 'uuid/v4';

export default {
    name: 'Audit',
    components: {RegionMultiSelect, SiteTypeSelect, YearSelect, SiteMultiSelect},
    data() {
        return {
            auditTypes: [
                {type: null, name: this.$t('all')},
                {type: 'E', name: this.$t('externalAudit')},
                {type: 'I', name: this.$t('internalAudit')},
                {type: 'C', name: this.$t('control')}
            ],
            selectedYear: null,
            selectedAuditType: null,
            selectedSite: {id: 0},
            searchInput: '',
            tempAudits: [],
            regions: [],
            Audits: [],
            filteredAudits: []
        };
    },
    methods: {
        selectAuditType(type) {
            this.getData(this.selectedYear, this.route.params.site_id, type);
        },
        selectSiteId(selectedSite) {
            this.selectedSite = selectedSite;
            this.$store.state.siteId = selectedSite ? selectedSite.id : null;
            if(selectedSite){
                this.getData(this.selectedYear, selectedSite.id, this.selectedAuditType);
                this.$router.push({
                    name: 'Detail',
                    params: {site_id: _.get(this.selectedSite, 'id')},
                    query: {year: this.selectedYear}
                });
            }
            else{
                this.selectedSite = null;
                this.$router.push({name: 'Summary', query: {year: this.year}});
            }
            
        },
        deleteAudit(audit, $event) {
            if (audit) {
                this.showWarnModal($event.target);
                this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                    let deleteData = {
                        site_id: audit.site_id,
                        record_id: audit.record_id,
                        type: audit.type,
                        date: audit.audit_date,
                        files: audit.files
                    };
                    this.axios.post(`/audit/delete/`, deleteData).then(() => {
                        this.getData(
                            this.selectedYear,
                            this.route.params.site_id,
                            this.selectedAuditType
                        );
                    });
                });
                
            }
        },
        getAuditType(type) {
            switch (type) {
                case 'E':
                    return this.$t('externalAudit');
                case 'I':
                    return this.$t('internalAudit');
                case 'C':
                    return this.$t('control');

                default:
                    return null;
            }
        },
        getSiteName(siteId) {
            let found = _.find(this.$store.state.sites, {id: Number(siteId)});
            if (found) {
                return found.name;
            }
        },
        getData(selectedYear, siteId, auditType) {
            this.axios
                .get(`/audits/records/details/${siteId}/?year=${selectedYear}&type=${auditType}`)
                .then(({data}) => {
                    this.Audits = data;
                })
                .then(() => {
                    this.$forceUpdate();
                });
        },
        // Update a table row
        updateRow(target, audit, editType) {
            this.$store.commit('SET_MODAL', {
                eventId: uuid(),
                type: 'createAudit',
                payload: {
                    editType: editType,
                    post: audit,
                    reloadFunction: this.getData,
                    siteId: this.route.params.site_id,
                    selectedType: this.selectedAuditType,
                    selectedYear: this.selectedYear
                }
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createAudit', target);
            });
        },
        // Insert a new table row
        insertRow(target, editType) {
            this.$store.commit('SET_MODAL', {
                eventId: uuid(),
                type: 'createAudit',
                payload: {
                    siteId: this.route.params.site_id,
                    editType: editType,
                    reloadFunction: this.getData,
                    selectedType: this.selectedAuditType,
                    selectedYear: this.selectedYear
                }
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createAudit', target);
            });
        },
        onYearChange(newYear) {
            this.selectedYear = newYear;
            this.$router.push({
                name: 'Detail',
                query: {year: newYear}
            });
            this.$Progress.start();
            this.getData(newYear, this.route.params.site_id, this.selectedAuditType);
        },
        showAuditFiles(files, target) {
            this.$store.commit('SET_MODAL', {
                eventId: uuid(),
                type: 'auditFiles',
                payload: {
                    files: files
                }
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'auditFiles', target);
            });
        },
    },
    computed: {
        filterAudits() {
            this.filteredAudits = _.filter(this.Audits, audit => {
                let searchName =
                    audit.title +
                    ' ' +
                    audit.accountable_first_name +
                    ' ' +
                    audit.accountable_last_name;
                if (searchName.toLowerCase().includes(this.searchInput.toLowerCase())) {
                    return audit;
                }
            });
        }
    },
    created() {
        this.selectedYear = Number(this.route.query.year);
        this.$store.state.year = Number(this.route.query.year);
        this.$store.state.siteId = this.route.params.site_id;
        this.$store.state.redirection = true;
        this.getData(this.selectedYear, this.route.params.site_id, this.selectedAuditType);
        this.selectedSite = this.route.params.site_id
            ? _.find(this.$store.state.sites, {id: Number(this.route.params.site_id)})
            : null;
        this.$Progress.start();
    }
};
</script>
<style scoped lang="scss">
.insert-row:hover {
    background-color: #ececec;
}
.audit-record-edit-buttons {
    background-color: white;
    -webkit-box-shadow: -8px 2px 8px -3px rgba(0, 0, 0, 0.29);
    -moz-box-shadow: -8px 2px 8px -3px rgba(0, 0, 0, 0.29);
    box-shadow: -8px 2px 8px -3px rgba(0, 0, 0, 0.29);
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "Başlık",
            "auditType": "Denetim Tipi",
            "auditDate": "Denetim Tarihi",
            "document": "Doküman",
            "searchRecord": "Denetim Arama"
        },
        "en": {
            "title": "Title",
            "auditType": "Audit Type",
            "auditDate": "Audit Date",
            "document": "Document",
            "searchRecord": "Search Audit"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Audit/AuditRecords/Detail.vue